<template>
  <div class="headline-bookmarks">
    <BaseButton class="headline-bookmarks--button" size="large" @click.native="toggleBookmark()">
      <i class="fa-light fa-bookmark" :class="isBookmarked ? 'fa-solid' : 'fa-light'" />
      {{ isBookmarked ? $t('bookmark.saved') : $t('bookmark.save') }}
    </BaseButton>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { CustomerData } from '@root/modules/customer/types/customer';

interface Props {
  headlineId: number;
}

interface Computed {
  isBookmarked: boolean;
  customerToken: string;
  bookmarks: CustomerData[];
}

interface Methods {
  toggleBookmark: () => void;
}

export default Vue.extend<unknown, Methods, Computed, Props>({
  name: 'HeadlineBookmarks',
  props: {
    headlineId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isBookmarked() {
      const isBookmarked = this.bookmarks.find((item: CustomerData) => item.value === String(this.headlineId));
      return !!isBookmarked;
    },
    customerToken() {
      return this.$store.state.piano.token;
    },
    bookmarks() {
      return this.$store.getters['bookmarks/getBookmarks'];
    },
  },
  methods: {
    async toggleBookmark() {
      await this.$store.dispatch('bookmarks/toggleBookmark', {
        headlineId: this.headlineId,
        customerToken: this.customerToken,
      });
    },
  },
});
</script>
<style lang="scss">
.headline-bookmarks {
  &--button {
    padding: 0 !important;
    margin-top: 12px;

    span {
      display: flex;
      align-items: center;
      gap: 10px;

      i {
        color: var(--color-color-1);
        font-size: 16px;
      }
    }
  }
}
</style>
